export default () => ({
  search: {
    padding: 12,
  },
})
